<div [ngClass]="isLoggedIn ? '':'body'">
<span class="fa fa-spinner spinner"
      *ngIf="loading"></span>

<div class="page-header sticky-top" style="height:130px;">
<nav class="navbar navbar-expand navbar-light">
  <a class="navbar-brand" href="https://www.nccommerce.com">
    <img viewbox="0 0 300 102" src="https://tools.nccareers.org/img/lead_logo.svg" alt="NC Department of Commerce Logo">
  </a>
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link"
         [routerLink]="['/license']"
         routerLinkActive="active">Home</a>
    </li>
    <li class="nav-item"
        *ngIf="!isLoggedIn">
      <a class="nav-link"
         [routerLink]="['/about']"
         routerLinkActive="active">About</a>
    </li>
    <li class="nav-item"
        *ngIf="isLoggedIn">
      <a class="nav-link"
        [routerLink]="['/authority']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact : false}">Authorities</a>
    </li>
    <li class="nav-item" *ngIf="isBlncAdmin || isLeadAdmin">
      <a class="nav-link"
        [routerLink]="['/resource']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact : false}">Resources</a>
    </li>
    <li class="nav-item" *ngIf="isBlncAdmin || isLeadAdmin">
      <a class="nav-link"
        [routerLink]="['/user']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact : false}">Users</a>
    </li>
  </ul>
  <ul class="navbar-nav ml-auto">
    <li class="nav-item"
        *ngIf="isLoggedIn">
      <a class="nav-link"
         [routerLink]="['/user',coordId,'edit']">Welcome {{ userName }}</a>
    </li>
    <li class="nav-item"
        *ngIf="!isLoggedIn">
      <a class="nav-link"
         (click)="login()">Log In</a>
    </li>
    <li class="nav-item"
        *ngIf="isLoggedIn">
      <a class="nav-link"
         (click)="logOut()">Log Out</a>
    </li>
  </ul>
</nav>
</div>
<p>
<div class="col-md-12" style="text-align:center; color:red"><b>{{idleState}}</b></div>
<div class="col-md-12"
      [@slideInAnimation]="o.isActivated ? o.activatedRoute : ''">
  <router-outlet #o="outlet"></router-outlet>  
</div>
</div>